<!-- 咨询回复 -->
<template>
    <div class="consulte-reply-wrap">
        <bread-crumb :bread-list="breadList" />
        <div class="consulte-reply-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">咨询回复</span>
            </div>
            <!-- 筛选条件 -->
            <div class="options">
                <div class="option-item">
                    <el-radio-group v-model="selectForm.radio"
                                    size="mini"
                                    @change="radioChange">
                        <el-radio-button label="1">近30日</el-radio-button>
                        <el-radio-button label="2">近7日</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="option-item">
                    <span class="label">反馈时间</span>
                    <el-date-picker size="mini"
                                    clearable
                                    clear-icon="el-icon-error"
                                    v-model="selectForm.picker"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :style="{width: '240px'}"
                                    :picker-options="pickerOptions"
                                    @change="datePickerChange"></el-date-picker>
                </div>
                <div class="option-item">
                    <span class="label">手机号</span>
                    <el-input class="search-input"
                              size="mini"
                              placeholder="请输入手机号"
                              v-model="selectForm.phone"
                              :style="{width: '240px!important'}"
                              @keyup.enter.native="getTableChangeList(1)">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="getTableChangeList(1)"></i>
                    </el-input>
                </div>
                <div class="option-item">
                    <span class="label">留言分类</span>
                    <el-select size="small"
                               :style="{width: '100px!important'}"
                               v-model="selectForm.type"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option v-for="item in typeFilters"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="options"
                 style="margin-top: 10px;">
                <div class="option-item">
                    <span class="label">昵称</span>
                    <el-input class="search-input"
                              size="mini"
                              placeholder="请输入昵称"
                              v-model="selectForm.nickName"
                              :style="{width: '200px!important'}"
                              @keyup.enter.native="getTableChangeList(1)">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="getTableChangeList(1)"></i>
                    </el-input>
                </div>
                <div class="option-item">
                    <span class="label">来源</span>
                    <el-select size="small"
                               :style="{width: '100px!important'}"
                               v-model="selectForm.userSource"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option v-for="item in originFilters"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="option-item">
                    <span class="label">状态</span>
                    <el-select size="small"
                               :style="{width: '100px!important'}"
                               v-model="selectForm.advisoryStatus"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option v-for="item in statusFilters"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>

                <div class="option-item">
                    <span class="label">精彩留言</span>
                    <el-select size="small"
                               :style="{width: '100px!important'}"
                               v-model="selectForm.wonderfulMsg"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option value="true"
                                   label="是">是</el-option>
                        <el-option value="false"
                                   label="否">否</el-option>
                    </el-select>
                </div>

                <div class="option-item">
                    <span class="label">标签</span>
                    <el-select size="small"
                               :style="{width: '100px!important'}"
                               v-model="selectForm.sign"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option v-for="item in tagOptions"
                                   :key="item.incId"
                                   :label="item.dictDataValue"
                                   :value="item.dictDataCode"></el-option>
                    </el-select>
                </div>
                <div class="option-item">
                    <span class="label">是否展示</span>
                    <el-select size="small"
                               :style="{width: '110px!important'}"
                               v-model="selectForm.showType"
                               @change="getTableChangeList(1)">
                        <el-option value="">全部</el-option>
                        <el-option v-for="item in showTypeFilters"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="option-item">
                    <el-button size="small"
                               type="primary"
                               @click="handleExport">导出数据</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <div class="table-wrap">
                <el-table :data="tableList"
                          stripe
                          v-loading="loading"
                          style="width:100%"
                          ref="filterTable"
                          @sort-change="handleSortChange">
                    <el-table-column width="50"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incrementId"
                                     width="80"
                                     label="编号"
                                     sortable="custom"></el-table-column>
                    <el-table-column prop="userSource"
                                     width="50"
                                     label="来源"
                                     :formatter="valueFormatter"></el-table-column>
                    <el-table-column prop="type"
                                     width="70"
                                     label="分类"
                                     :formatter="valueFormatter"></el-table-column>
                    <el-table-column prop="nickname"
                                     label="用户昵称"
                                     width="100"></el-table-column>
                    <el-table-column prop="phone"
                                     label="手机号"
                                     width="100"></el-table-column>
                    <el-table-column prop="advisoryTime"
                                     label="提问时间"
                                     width="160"></el-table-column>
                    <el-table-column prop="content"
                                     min-width="200px"
                                     label="问题"></el-table-column>
                    <el-table-column prop="reply"
                                     min-width="200px"
                                     label="回复"></el-table-column>

                    <el-table-column min-width="180px"
                                     label="排序编号"
                                     v-if="wonderfulSortShow">
                        <template slot-scope="{row}">
                            <div v-if="row.sortEdit">
                                <el-input placeholder="请输入排序编号"
                                          v-model="row.wonderfulSort"
                                          class="reply-input"
                                          oninput="value=value.replace(/[^\d]/g,'')"
                                          maxlength="10">
                                </el-input>
                                <el-button @click="handleReplySortSave(row)"
                                           class="reply-save-btn"
                                           size="small"
                                           type="primary">保存</el-button>
                                <el-button @click="row.sortEdit=false"
                                           class="reply-save-btn"
                                           size="small"
                                           type="info">取消</el-button>
                            </div>
                            <div v-else
                                 class="is-wonderfulMsg">
                                <span>
                                    {{ row.wonderfulSort }}
                                </span>
                                <img src="../../../assets/imgs/reply_edit.png"
                                     class="reply-edit"
                                     @click="handleReplySort(row)" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180px"
                                     label="精彩留言">
                        <template slot-scope="{row}">
                            <div v-if="row.msgEdit">
                                <el-select v-model="row.wonderfulMsg"
                                           class="reply-select">
                                    <el-option :value="true"
                                               label="是">是</el-option>
                                    <el-option :value="false"
                                               label="否">否</el-option>
                                </el-select>
                                <el-button @click="handleReplyMsgSave(row)"
                                           class="reply-save-btn"
                                           size="small"
                                           type="primary">保存</el-button>
                                <el-button @click="row.msgEdit=false"
                                           class="reply-save-btn"
                                           size="small"
                                           type="info">取消</el-button>

                            </div>
                            <div v-else
                                 class="is-wonderfulMsg">
                                <span v-if="row.wonderfulMsg">
                                    是
                                </span>
                                <span v-else>
                                    否
                                </span>
                                <img src="../../../assets/imgs/reply_edit.png"
                                     class="reply-edit"
                                     @click="handleReplyMsg(row)" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180px"
                                     label="点赞量">
                        <template slot-scope="{row}">
                            <div v-if="row.likesEdit">
                                <el-input placeholder="请输入点赞量"
                                          v-model="row.likes"
                                          class="reply-input"
                                          oninput="value=value.replace(/[^\d]/g,'')"
                                          maxlength="20">
                                </el-input>
                                <el-button @click="handleReplyLikesSave(row)"
                                           class="reply-save-btn"
                                           size="small"
                                           type="primary">保存</el-button>
                                <el-button @click="row.likesEdit=false"
                                           class="reply-save-btn"
                                           size="small"
                                           type="info">取消</el-button>
                            </div>
                            <div v-else
                                 class="is-wonderfulMsg">
                                <span>
                                    {{ row.likes }}
                                </span>
                                <img src="../../../assets/imgs/reply_edit.png"
                                     class="reply-edit"
                                     @click="handleReplyLikes(row)" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="advisoryStatus"
                                     label="状态"
                                     width="100"
                                     column-key="advisoryStatus"
                                     :formatter="valueFormatter">
                        <template slot-scope="scope">
                            <div v-if="scope.row.advisoryStatus === 'WD'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item"></el-badge>
                                <span class="status_text">未回答</span>
                            </div>
                            <div v-else-if="scope.row.advisoryStatus === 'WS'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="warning"
                                          class="item"></el-badge>
                                <span class="status_text">未审核</span>
                            </div>
                            <div v-else-if="scope.row.advisoryStatus === 'SHTG'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item"></el-badge>
                                <span class="status_text">审核通过</span>
                            </div>
                            <div v-else-if="scope.row.advisoryStatus === 'SHSB'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="danger"
                                          class="item"></el-badge>
                                <span class="status_text">审核失败</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="展示"
                                     width="120">
                        <template slot-scope="{row}">
                                  <el-select size="mini"
                                        v-model="row.showType"
                                        @change="changeShowType(row)">
                                    <el-option v-for="item in showTypeFilters"
                                            :key="item.value"
                                            :label="item.text"
                                            :value="item.value"></el-option>
                                </el-select>

                        </template>
                    </el-table-column>
                    <el-table-column prop="sign"
                                     label="标签"
                                     width="100"
                                     sortable="custom"
                                     column-key="sign">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.sign"
                                       size="mini"
                                       placeholder
                                       @change="((val)=>{changeTag(val,scope.row,scope.$index)})">
                                <el-option v-for="item in tagOptions"
                                           :key="item.incId"
                                           :label="item.dictDataValue"
                                           :value="item.dictDataCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"
                                     width="140"
                                     fixed="right">
                        <template slot-scope="{row}">
                            <span :class="[answerDis(row)?'disableStyle': 'activeStyle','link-btn']"
                                  @click="handleReply(row)">回复</span>
                            <span :class="[auditDis(row)?'disableStyle': 'activeStyle','link-btn']"
                                  @click="handleAudit(row)">审核</span>

                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <!-- 分页 -->
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
            <!-- 回复弹窗 -->
            <el-dialog title="回复内容"
                       :visible.sync="dialogFormVisible"
                       width="40%"
                       center>
                <el-form :model="form">
                    <el-form-item label
                                  label-width="80">
                        <el-input type="textarea"
                                  :rows="4"
                                  placeholder="请输入内容"
                                  v-model="form.content"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer"
                     class="dialog-footer">
                    <el-button @click="dialogFormVisible = false"
                               size="mini">取消</el-button>
                    <el-button type="primary"
                               @click="handleConfirmReply"
                               size="mini">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { selectAdvisory, reply, review, sign, postWonderfulSort, postWonderfulLikes, postWonderfulMsg, postChangeShowType } from '@/api/consulting'
import { mapGetters } from 'vuex'
export default {
    components: {},
    data () {
        return {
            breadList: [
                { label: '咨询专区' },
                { label: '咨询回复' }
            ],
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now()
                }
            },
            // 选择条件
            selectForm: {
                radio: '',
                picker: '',
                phone: '',
                sign: '',
                advisoryStatus: '',
                nickName: '',
                isShow: '',
                wonderfulMsg: '',
                userSource: '',
                showType: ''
            },
            // 开始结束日期
            advisoryTimeStart: '',
            advisoryTimeEnd: '',
            // 表格
            loading: false,
            tagOptions: [],
            statusFilters: [],
            tagFilter: [],
            tableList: [],
            originFilters: [],
            showTypeFilters: [],
            // 分页
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            // 弹窗
            dialogFormVisible: false,
            form: {
                content: ''
            },
            // 当前行
            currentRow: null,
            typeFilters: {},
            desc: [],
            ascs: [],
            typeMap: {},
            tagMap: {},
            statusMap: {}
        }
    },
    mounted () {
        this.getTableList()
        this.getDictionary()
    },
    computed: {
        ...mapGetters([
            'userInfo',
            'dictionary'
        ]),
        wonderfulSortShow () {
            if (this.selectForm.wonderfulMsg === 'true') {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        // 变更 国内展示 国外展示 国内外展示 不展示
        async changeShowType (dataRow) {
            let params = {
                advisoryId: dataRow.advisoryId,
                showType: dataRow.showType
            }
            const { results, state } = await postChangeShowType(params)
            console.log(dataRow, '9999999')
            if (results === 'SUCCESS' && state === 200) {
                this.$message({
                    message: '展示状态更改成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
            } else {
                this.$message.error('操作失败，请联系管理员！')
                this.getTableList(this.page.current)
            }
        },
        checkNumber (number) {
            // eslint-disable-next-line
            number = number.replace(/[^\.\d]/g, '')
            number = number.replace('.', '')
        },
        // 点击 精彩留言 行内编辑
        handleReplyMsg (row) {
            row.msgEdit = true
        },
        // 点击 精彩留言 行内保存
        async handleReplyMsgSave (row) {
            let params = {
                wonderfulMsg: row.wonderfulMsg,
                advisoryId: row.advisoryId
            }
            const { results } = await postWonderfulSort(params)
            if (results === 'SUCCESS') {
                this.$message({
                    message: '精彩留言保存成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                // row.wonderfulMsg = row.wonderfulMsg
                // this.getTableList(this.page.current)
                row.msgEdit = false
            } else {
                this.$message.error('操作失败，请联系管理员！')
            }
        },
        // 点击 点赞量 行内编辑
        handleReplyLikes (row) {
            row.likesEdit = true
        },
        // 点击 点赞量 行内保存
        async handleReplyLikesSave (row) {
            let params = {
                likes: parseInt(row.likes),
                advisoryId: row.advisoryId
            }
            const { results } = await postWonderfulLikes(params)
            if (results === 'SUCCESS') {
                this.$message({
                    message: '点赞量保存成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                row.likes = parseInt(row.likes)
                // this.getTableList(this.page.current)
                row.likesEdit = false
            } else {
                this.$message.error('操作失败，请联系管理员！')
            }
        },
        // 点击 排列编号 行内编辑
        handleReplySort (row) {
            row.sortEdit = true
        },
        // 点击 排列编号 行内保存
        async handleReplySortSave (row) {
            let params = {
                wonderfulSort: parseInt(row.wonderfulSort),
                advisoryId: row.advisoryId
            }
            const { results } = await postWonderfulMsg(params)
            if (results === 'SUCCESS') {
                this.$message({
                    message: '排列编号保存成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                row.wonderfulSort = parseInt(row.wonderfulSort)
                // this.getTableList(this.page.current)
                row.sortEdit = false
            } else {
                this.$message.error('操作失败，请联系管理员！')
            }
        },
        // 获取字典
        getDictionary () {
            // 标签
            this.tagOptions = this.dictionary['ZXBQ']
            this.tagFilter = this.formatList(this.tagOptions)
            // 状态
            let status = this.dictionary['ZXZT']
            this.statusFilters = this.formatList(status)
            // 分类
            this.typeFilters = this.formatList(this.dictionary['ZXFL'])
            // 来源
            this.originFilters = this.formatList(this.dictionary['FYZXYHLY'])
            // 展示类型
            this.showTypeFilters = this.formatList(this.dictionary['FYZXZSLX'])

            this.tagMap = this.mapList(this.tagOptions)
            this.statusMap = this.mapList(status)
            this.typeMap = this.mapList(this.dictionary['ZXFL'])
        },
        mapList (arr) {
            let obj = {}
            arr.forEach((item) => {
                obj[item.dictDataCode] = item.dictDataValue
            })
            return obj
        },
        formatList (arr) {
            let newarr = []
            arr.forEach((item) => {
                let obj = {
                    text: item.dictDataValue,
                    value: item.dictDataCode
                }
                newarr.push(obj)
            })
            return newarr
        },
        // 选择30天/7天
        radioChange (val) {
            let currentDate = new Date()
            let currentTime = currentDate.getTime()
            let monthBefore = new Date(currentTime - 30 * 24 * 60 * 60 * 1000)
            let weekendBefore = new Date(currentTime - 7 * 24 * 60 * 60 * 1000)
            this.advisoryTimeEnd = this.formatTime('YYYY-mm-dd HH:MM:SS', currentDate)
            this.advisoryTimeStart = val === '1' ? this.formatTime('YYYY-mm-dd HH:MM:SS', monthBefore) : this.formatTime('YYYY-mm-dd HH:MM:SS', weekendBefore)
            this.selectForm.picker = ''
            this.getTableChangeList(1)
        },
        formatTime (fmt, date) {
            let ret
            let opt = {
                'Y+': date.getFullYear().toString(), // 年
                'm+': (date.getMonth() + 1).toString(), // 月
                'd+': date.getDate().toString(), // 日
                'H+': date.getHours().toString(), // 时
                'M+': date.getMinutes().toString(), // 分
                'S+': date.getSeconds().toString() // 秒
            }
            for (let k in opt) {
                ret = new RegExp('(' + k + ')').exec(fmt)
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
                };
            };
            return fmt
        },
        // 排序
        handleSortChange (column) {
            let prop = column.prop === 'incrementId' ? 'increment_id' : column.prop
            let ascsIndex = this.ascs.indexOf(prop)
            if (ascsIndex !== -1) {
                this.ascs.splice(ascsIndex, 1)
            }
            let descIndex = this.desc.indexOf(prop)
            if (descIndex !== -1) {
                this.desc.splice(descIndex, 1)
            }
            if (column.order === 'ascending') {
                this.ascs.unshift(prop)
            } else if (column.order === 'descending') {
                this.desc.unshift(prop)
            }
            this.getTableChangeList(1)
        },
        // 格式化字典
        valueFormatter (row, column) {
            let key = column['property']
            let valueArr = ['XLGS', 'WXQZ', 'SZSJ', 'WXGX', 'BDLY', 'CBTJ', 'MDFF', 'JBZX', 'JJFH', 'CXZS', 'GLFK', 'ZJPY', 'WD', 'WS', 'SHTG', 'SHSB', '0', '1', '2', '3', '4', '5', '6', '7', 'OUTER', 'INNER']
            let textArr = ['心灵故事', '我想求助', '是真是假', '我想感谢', '病毒来源', '传播途径', '灭毒方法', '疾病咨询', '家居防护', '出行知识', '隔离防控', '真假辟谣', '未回答', '未审核', '审核通过', '审核失败', '普通', '新', '热', '爆', '新热', '新爆', '热爆', '新热爆', '国外', '国内']
            let index = valueArr.findIndex((value) => { return value === row[key] })
            return textArr[index]
        },
        // 回复
        handleReply (row) {
            if (!this.answerDis(row)) {
                this.dialogFormVisible = true
                this.currentRow = row
                this.form.content = row.reply
            } else {
                return false
            }
        },
        async handleConfirmReply () {
            let row = this.currentRow
            let params = {
                advisoryId: row.advisoryId,
                reply: this.form.content,
                replyer: this.userInfo.accountName
            }
            const { results } = await reply(params)
            if (results === 'SUCCESS') {
                row.reply = this.form.content
                this.$message({
                    message: '成功回复信息',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.dialogFormVisible = false
                // 回复成功 变成未审核
                row.advisoryStatus = 'WS'
                // this.getTableList(this.page.current)
            } else {
                this.$message.error('操作失败，请联系管理员！')
            }
        },
        // 审核
        async handleAudit (row) {
            if (!this.answerDis(row)) {
                let params = {
                    advisoryId: row.advisoryId,
                    reviewer: this.userInfo.accountName,
                    status: 'SHTG'
                }
                const { results } = await review(params)
                if (results === 'SUCCESS') {
                    row.advisoryStatus = 'SHTG'
                    this.$message({
                        message: '审核成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                } else {
                    this.$message.error('操作失败，请联系管理员！')
                }
            } else {
                return false
            }
        },
        // 展示
        // async handleShow (row) {
        //     let params = {
        //         advisoryId: row.advisoryId,
        //         isShow: !row.isShow
        //     }
        //     const { results } = await show(params)
        //     if (results === 'SUCCESS') {
        //         row.isShow = !row.isShow
        //         if (row.isShow) {
        //             this.$message({
        //                 message: '成功展示',
        //                 customClass: 'hos-message--success',
        //                 iconClass: 'el-icon-success',
        //                 duration: '2000'
        //             })
        //         } else {
        //             this.$message({
        //                 message: '已取消展示',
        //                 customClass: 'hos-message--success',
        //                 iconClass: 'el-icon-success',
        //                 duration: '2000'
        //             })
        //         }
        //     } else {
        //         this.$message.error('操作失败，请联系管理员！')
        //     }
        // },
        // 选择日期
        datePickerChange (val) {
            this.selectForm.radio = ''
            this.advisoryTimeStart = ''
            this.advisoryTimeEnd = ''
            if (val) {
                this.advisoryTimeStart = val[0]
                this.advisoryTimeEnd = val[1]
            }
            this.getTableChangeList(1)
        },
        // select change事件
        getTableChangeList () {
            this.page.current = 1
            this.getTableList(1)
        },
        // 获取表格列表
        getTableList (val) {
            let current = val ? this.page.current : 1
            let params = {
                size: this.page.pageSize,
                current: current,
                advisoryTimeStart: this.advisoryTimeStart,
                advisoryTimeEnd: this.advisoryTimeEnd
            }
            Object.assign(params, this.selectForm)
            params.ascs = this.ascs
            params.descs = this.desc
            this.getListApi(params)
        },
        async getListApi (params) {
            this.loading = true
            this.tableList = []
            let { results, total } = await selectAdvisory(params)
            this.tableList = results.map(v => {
                this.$set(v, 'msgEdit', false)
                this.$set(v, 'likesEdit', false)
                this.$set(v, 'sortEdit', false)
                return v
            })
            this.page.total = total
            this.loading = false
        },
        // 初始化用户权限
        answerDis (val) {
            return val.advisoryStatus === 'SHTG'
        },
        auditDis (val) {
            let roles = this.userInfo.roles || []
            let roleName = []
            roles.forEach(ele => {
                roleName.push(ele.roleName)
            })
            // console.log(roleName)
            return val.advisoryStatus === 'WD' || val.advisoryStatus === 'SHTG' || roleName.indexOf('审核员') > -1
        },
        // 修改标签
        async changeTag (val, row, index) {
            let params = {
                advisoryId: row.advisoryId,
                sign: val
            }
            const { results } = await sign(params)
            if (results === 'SUCCESS') {
                this.getTableList(this.page.current)
            }
        },
        // 翻页
        handlePageChange (val) {
            this.page.current = val
            this.getTableList(val)
        },
        // 导出列表数据
        formatWayJson (filterVal, jsonData) {
            return jsonData.map((v, index) => {
                v.type = this.typeMap[v.type]
                v.advisoryStatus = this.statusMap[v.advisoryStatus]
                v.sign = this.tagMap[v.sign]
                return filterVal.map((j) => {
                    if (j === 'index') {
                        return (index + 1)
                    } else {
                        return v[j]
                    }
                })
            })
        },
        async getExportList () {
            let params = {
                size: 10000,
                current: 1,
                advisoryTimeStart: this.advisoryTimeStart,
                advisoryTimeEnd: this.advisoryTimeEnd
            }
            Object.assign(params, this.selectForm)
            params.ascs = this.ascs
            params.descs = this.desc
            this.loading = true
            let { results } = await selectAdvisory(params)
            this.loading = false
            return new Promise((resolve) => {
                resolve(results)
            })
        },
        handleExport () {
            this.getExportList().then(res => {
                let list = res
                this.loading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = ['编号', '分类', '用户昵称', '手机号', '提问时间', '问题', '回复', '状态', '标签']
                    const filterVal = ['incrementId', 'type', 'nickname', 'phone', 'advisoryTime', 'content', 'reply', 'advisoryStatus', 'sign']
                    if (list.length > 0) {
                        const data = this.formatWayJson(filterVal, list)
                        let filename = '用户数据'
                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: filename,
                            autoWidth: true,
                            bookType: 'xlsx'
                        })
                        this.loading = false
                    } else {
                        this.$message({
                            message: '无数据导出！',
                            type: 'warning',
                            center: true
                        })
                        this.loading = false
                    }
                })
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        console.log(to, from, next)
        next()
    }
}
</script>
<style lang='scss'>
.consulte-reply-wrap {
    height: calc(100% - 90px);
    .status-warp {
        line-height: 12px;
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }
        }
        .status_text {
            margin-left: 10px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 12px;
        }
    }
    .consulte-reply-content {
        height: 100%;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
    }
    .options {
        display: flex;
        justify-content: flex-start;
        .option-item {
            margin: 0 20px;
            .label {
                padding-right: 10px;
                font-size: 14px;
                color: #666;
                text-align: right;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .table-wrap {
        padding-top: 20px;
        .table-none {
            height: 300px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .icon {
                font-size: 100px;
            }
            span {
                line-height: 14px;
            }
        }
        .link-btn {
            font-size: 12px;
            display: inline-block;
            height: 14px;
            line-height: 14px;
            border-right: 1px solid $a-link;
            margin-right: 6px;
            padding-right: 6px;
            &:last-child {
                border-right: none;
                margin-right: 0;
                padding-right: 0;
            }
        }
        .activeStyle {
            color: $a-link;
            cursor: pointer;
        }
        .disableStyle {
            color: $disable-link;
            cursor: not-allowed;
        }
        .el-select .el-tag__close.el-icon-close {
            display: none;
        }
        .el-select .el-tag--info {
            color: #3b8fb9;
            background-color: #f4f4f5;
        }
        .el-table__header-wrapper {
            overflow: auto;
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
        .el-table .caret-wrapper {
            height: 18px;
        }
        .el-table .sort-caret.ascending {
            top: -2px;
        }
        .el-table .sort-caret.descending {
            bottom: -2px;
        }
        .reply-edit {
            width: 20px;
            height: 20px;
            margin-left: 20px;
            cursor: pointer;
        }
        .reply-input {
            width: 50px;
            .el-input__inner {
                border-radius: 2px;
                height: 30px;
                padding: 0 5px;
            }
        }
        .reply-select {
            width: 50px;
            .el-input__inner {
                border-radius: 2px;
                height: 30px;
                padding: 0 10px;
            }
            .el-input__prefix {
                .el-input__icon {
                    line-height: 30px;
                }
            }
            .el-input__suffix {
                .el-input__icon {
                    line-height: 30px;
                }
            }
        }
        .is-wonderfulMsg {
            display: flex;
            align-items: center;
        }
        .reply-save-btn {
            margin-left: 10px;
            padding: 0;
            height: 28px;
            width: 40px;
        }
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .el-dialog__body {
        padding: 25px 30px 0 30px;
    }
    input::-webkit-input-placeholder {
        font-size: 13px;
    }
}
</style>
